import { useContext } from 'react'
import { NotificationContext } from '../contexts/NotificationsContextProvider'

export const useNotifications = () => useContext( NotificationContext )